import { render, staticRenderFns } from "./NotificationModal.vue?vue&type=template&id=476de000&scoped=true"
import script from "./NotificationModal.vue?vue&type=script&lang=ts"
export * from "./NotificationModal.vue?vue&type=script&lang=ts"
import style0 from "./NotificationModal.vue?vue&type=style&index=0&id=476de000&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476de000",
  null
  
)

export default component.exports